// COMPONENTS
import { ButtonGroup } from "@allaria-tech/matter/ButtonGroup";
import { Feedback } from "@allaria-tech/matter/Feedback";

// UTILS
import { postToParent } from "../../utils/crypto";
import useMobileLayout from "../../hooks/useMobileLayout";

// STYLES
import styles from "./CryptoMissingDraft.module.scss";

// Without a draft the onboarding cannot start, so all the user can do is close.
// Laid out as the phone and terms steps: in the app's frame narrow widths drop
// the card's border, shadow and footer, so the error reads as the app's modal
// itself, and "Cerrar" goes below it as those steps' buttons do.
const CryptoMissingDraft = () => {
  const { isMobile } = useMobileLayout();

  const handleClose = () => postToParent("DIGITAL_ONBOARDING_CLOSE");

  return (
    <section className={`${styles.container} ${isMobile ? styles.phone : ""}`}>
      <Feedback
        inline
        type="ERROR"
        title="Algo salió mal"
        description="No pudimos iniciar la apertura de tu cuenta. Por favor, intentá nuevamente."
      />
      <ButtonGroup
        container={isMobile}
        containerClassName={styles.buttons}
        align="center"
        disableMobileLayout={!isMobile}
        secondary={{ text: "Cerrar", type: "button", onClick: handleClose }}
      />
    </section>
  );
};

export default CryptoMissingDraft;
